import { render, staticRenderFns } from "./AdminColorsEditScreen.vue?vue&type=template&id=55b9bd44&scoped=true&"
import script from "./AdminColorsEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminColorsEditScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b9bd44",
  null
  
)

export default component.exports